<template>
  <div class="ai-tab-loader-container" v-if="isLoading">
    <DxLoadIndicator :height="40" :width="40" />
  </div>
  <div class="ai-customers-tab" v-else>
    <div class="count">{{ users.length }} total users</div>
    <DxList :data-source="users" display-expr="name"> </DxList>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import store from "../../store/index.js";
import aiService from "../../services/ai.service";
import { DxList } from "devextreme-vue/list";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

const isLoading = ref(true);

onMounted(async () => {
  await aiService.getAIUsers();
  isLoading.value = false;
});

const users = computed({
  get: () => store.state.user.aiUsersList
});
</script>
